import { OVERLAY_PADDING } from '../../core/components/data-point/constants.js';
import type { XYChartAxisInternal } from '../types/xy-chart-internals.js';

const AXES = ['top', 'bottom', 'left', 'right'] as const;
type Hidden = { hidden?: XYChartAxisInternal['hidden'] };
type GetPaddings = (
  axes: { [key in (typeof AXES)[number]]?: Hidden },
  padding?: number,
) => ReturnType<typeof Paddings>;

const Paddings = () => ({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  horizontal: function () {
    return this.left + this.right;
  },
  vertical: function () {
    return this.top + this.bottom;
  },
});

export const getPaddingByAxes: GetPaddings = (
  axes,
  padding = OVERLAY_PADDING,
) => {
  return AXES.reduce((acc, axis) => {
    acc[axis] = axes[axis] && !axes[axis].hidden ? 0 : padding;

    return acc;
  }, Paddings());
};
